angular.module('impactx.catalog').service('CatalogActionsService', [
    '$redirect',
    'WarningService',
    'TranslationService',
    'ToastService',
    'CatalogCheckinService',
    'dataGen',
    'ConfirmationService',
    '$mdDialog',
    'CatApprovalService',
    CatalogActionsService]);

function CatalogActionsService($redirect, WarningService, TranslationService, ToastService, CatalogCheckinService, dataGen, ConfirmationService, $mdDialog, CatApprovalService) {
    var self = this;

    self.replace = function (catalogId) {
        $redirect.redirectTo(null, '/suppliercatalogupload/' + catalogId);
    };

    self.replaceOnApprovalProcess = function (event, catalogId, trns) {
        WarningService.showWarningDialog(redirectToCatalogImport,
            event,
            TranslationService.get("warning"),
            TranslationService.get("forward"),
            TranslationService.get("abort"),
            [trns.catalogInApproval],
            catalogId);
    };

    self.replaceOnOwnEdit = function (event, catalogId, trns) {
        WarningService.showWarningDialog(redirectToCatalogImport,
            event,
            TranslationService.get("warning"),
            trns.uploadNewVersion,
            TranslationService.get("abort"),
            [trns.catalogInOwnEdit],
            catalogId);
    };

    self.checkIn = function (catalogId) {
        var tmpScope = {};
        CatalogCheckinService.checkIn(tmpScope, catalogId).then(function () {
            ToastService.openStandardToast(tmpScope.trns.checkInStarted);
            $redirect.reload();
        });
    };

    self.checkOut = function (event, catalogId, trns) {
        ConfirmationService.showConfirmationDialog(function () {
            return checkout(catalogId);
        }, event, trns.checkoutWarning, trns.checkoutNow, trns.abort, trns.checkoutQuestion);
    };

    self.denyCheckedOut = function (catalogId, callback) {
        if (!callback) {
            callback = $redirect.reload;
        }
        CatApprovalService.denyCatalogDialog(catalogId, callback);
    };

    self.denyFailure = function (catalogId) {
        var tmpScope = {};
        dataGen.postAsForm(tmpScope, {catId: catalogId}, "/catalog/denyfailure").then(function () {
            ToastService.openStandardToast(tmpScope.trns.success);
            $redirect.reload();
        });
    };

    self.delete = function (catalogId) {
        var tmpScope = {};
        dataGen.postAsForm(tmpScope, {catId: catalogId}, "/catalog/delete").then(function () {
            ToastService.openStandardToast(tmpScope.trns.deleteSuccess);
            $redirect.reload();
        });
    };

    self.forwardToApproval = function (catalogId) {
        CatApprovalService.forwardToApproval(catalogId, $redirect.reload);
    };

    self.checkInAndForwardToApproval = function (catalogId) {
        CatApprovalService.checkInAndForwardToApproval(catalogId, $redirect.reload, $redirect.reload);
    };

    self.abortImport = function (catalogId) {
        var tmpScope = {};
        var dataObj = {catId: catalogId};
        dataGen.postAsForm(tmpScope, dataObj, "/catalog/abortimport").then(function () {
            ToastService.openStandardToast(tmpScope.trns.deleteSuccess);
            $redirect.reload();
        }, function () {
            $redirect.reload();
        });
    };

    self.abortRunningImport = function (catalogId) {
        var tmpScope = {};
        var dataObj = {catId: catalogId};
        dataGen.postAsForm(tmpScope, dataObj, "/catalog/abortrunningimport").then(function () {
            ToastService.openStandardToast(tmpScope.trns.abortSuccess);
            $redirect.reload();
        }, function () {
            $redirect.reload();
        });
    };

    self.abortApproval = function (event, catalogId, trns) {
        var confirm = $mdDialog.confirm()
            .title(trns.abortApprovalQuestion)
            .textContent(trns.abortApprovalQuestion2)
            .targetEvent(event)
            .ok(trns.abortApproval)
            .cancel(TranslationService.get('back'));

        $mdDialog.show(confirm).then(function () {
            dataGen.postAsForm({}, {cat: {id: catalogId}}, "/catalog/abortApproval").then(function (data) {
                ToastService.openStandardToast(data.trns.abortSuccess);
                $redirect.reload();
            });
        });
    };

    self.backToPurchaser = function (event, catalogId) {
        return $mdDialog.show({
            templateUrl: 'modules/catalog/templates/catalog-back-to-professional-dialog.tmpl.html',
            locals: {
                catId: catalogId
            },
            controller: "CatalogBackToProfessionalCtrl",
            controllerAs: "catalogBackToProfessionalCtrl",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            targetEvent: event,
            bindToController: true
        });
    };

    self.runChangeProtocolDialog = function (event, catalogId) {
        $mdDialog.show({
            controller: "CatalogChangeProtocolSelectionCtrl",
            controllerAs: "catalogChangeProtocolSelectionCtrl",
            templateUrl: "modules/catalog/templates/catalogchangeprotocolselection.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                catalogId: catalogId
            }
        });
    };

    function redirectToCatalogImport(catalogId) {
        $redirect.redirectTo(null, "suppliercatalogupload/" + catalogId)
    }

    function checkout(catalogId) {
        var tmpScope = {};
        dataGen.postAsForm(tmpScope, {cat: {id: catalogId}}, "/catalog/checkout").then(function () {
            $redirect.redirectTo(null, '/cataloglist');
            ToastService.openStandardToast(tmpScope.trns.checkoutSuccess);
        });
    }

    self.extendLastDate = function (event, data, trns) {
        return $mdDialog.show({
            controller: "ExtendCatalogLastDateCtrl",
            controllerAs: "extendCatalogLastDateCtrl",
            templateUrl: "modules/catalog/templates/catalogextendlastdate.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                trns: trns,
                newLastDateProduct: data.lastDateProduct
            }
        }).then(function (newLastDateProduct) {
            data.newLastDateProduct = newLastDateProduct;
            var dataObj = {
                cat: data
            };
            return dataGen.postAsForm({}, dataObj, "/catalog/extendlastdate");
        });
    };

    self.setFixDeliveryDate = function (event, data, trns) {
        return $mdDialog.show({
            controller: "FixDeliveryDateCtrl",
            controllerAs: "fixDeliveryDateCtrl",
            templateUrl: "modules/catalog/templates/catalogsetfixdeliverydate.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                trns: trns,
                fixDeliveryDate: data.fixDeliveryDate
            }
        }).then(function (fixDeliveryDate) {
            data.fixDeliveryDate = fixDeliveryDate;
            var dataObj = {
                cat: data
            };
            return dataGen.postAsForm({}, dataObj, "/catalog/setfixdeliverydate");
        });
    };

    return {
        replace: self.replace,
        replaceOnApprovalProcess: self.replaceOnApprovalProcess,
        replaceOnOwnEdit: self.replaceOnOwnEdit,
        checkIn: self.checkIn,
        checkOut: self.checkOut,
        checkInAndForwardToApproval: self.checkInAndForwardToApproval,
        forwardToApproval: self.forwardToApproval,
        deny: self.deny,
        denyCheckedOut: self.denyCheckedOut,
        delete: self.delete,
        abortApproval: self.abortApproval,
        abortImport: self.abortImport,
        backToPurchaser: self.backToPurchaser,
        abortRunningImport: self.abortRunningImport,
        runChangeProtocolDialog: self.runChangeProtocolDialog,
        denyFailure: self.denyFailure,
        extendLastDate: self.extendLastDate,
        setFixDeliveryDate: self.setFixDeliveryDate
    };
}